import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { DeletedScreenComponent } from './components/deleted-screen/deleted-screen.component'
import { LeaveGuard } from '@app/services/leave-guard.guard'
import { MasterGuard } from './services/master-guard.service'

const appRoutes: Routes = [
  {
    path: '',
    canActivateChild: [LeaveGuard],
    children: [
      {
        path: 'stories/connections/:storyid',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/connections/connections-routing').then((m) => m.CONNECTIONS_ROUTING), // lazy loading
        data: {
          screenName: 'family-story-page',
          appLoaderTitle: 'retrieving',
          memberPage: true,
          pageTitle: $localize`:Family Story Page | This page displays stories related to family members@@Stories259cb22e4ea2498aa6d733d843456ba6:Family Story Page`,
        },
      },
      {
        path: 'stories/mobile/connections/:storyid',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/connections/connections-routing').then((m) => m.CONNECTIONS_ROUTING), // lazy loading
        data: {
          screenName: 'family-story-page',
          appLoaderTitle: 'retrieving',
          memberPage: true,
          isMobileApp: true,
          pageTitle: $localize`:Family Story Page | This page displays stories related to family members@@Stories6b3275c3423c4f08b88f86629463277c:Family Story Page`,
        },
      },
      {
        path: 'stories/c/connections/:storyid',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/connections/connections-routing').then((m) => m.CONNECTIONS_ROUTING), // lazy loading
        data: {
          screenName: 'family-story-page',
          appLoaderTitle: 'retrieving',
          memberPage: true,
          isMobileApp: true,
          pageTitle: $localize`:Family Story Page | This page displays stories related to family members@@Stories167042e6f2a9447ab699db74ae243dc5:Family Story Page`,
          isContainer: true,
        },
      },
      {
        path: 'stories/public/connect',
        canActivate: [MasterGuard],
        loadChildren: () => import('@connect/connect-in-routing').then((m) => m.CONNECT_IN_ROUTING), // lazy loading
        data: {
          screenName: 'public-connect',
          campaignIsRequired: true,
          pageTitle: $localize`:Public Connect Page | This page allows users to connect publicly with others@@Stories0dd81423c3e34c02afd59557814a1ebc:Public Connect Page`,
        },
      },
      {
        path: 'stories/public/connections',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/connections/connections-routing').then((m) => m.CONNECTIONS_ROUTING), // lazy loading
        data: {
          screenName: 'family-story-page',
          campaignIsRequired: true,
          appLoaderTitle: 'looking',
          pageTitle: $localize`:Family Story Page | This page displays stories related to family members@@Stories9b9be68f6ded4cd5867278174d6d4906:Family Story Page`,
        },
      },
      {
        path: 'stories/losp',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/connections/connections-routing').then((m) => m.CONNECTIONS_ROUTING), // lazy loading
        data: {
          screenName: 'losp',
          isLosp: true,
          pageTitle: $localize`:Family Story Page | This page displays stories related to family members@@Storiesdc357e22fe7c4f8f95c965bb06c40872:Family Story Page`,
        },
      },
      {
        path: 'stories/notables/:storyid',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/connections/connections-routing').then((m) => m.CONNECTIONS_ROUTING), // lazy loading
        data: {
          screenName: 'notables',
          isAncestorLess: true,
          pageTitle: $localize`:Family Story Page | This page displays stories related to family members@@Storiesa083431f2cfa4ac7963c16246b7d5c16:Family Story Page`,
        },
      },
      {
        path: 'stories/c/losp',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/connections/connections-routing').then((m) => m.CONNECTIONS_ROUTING), // lazy loading
        data: {
          screenName: 'losp',
          isLosp: true,
          pageTitle: $localize`:Family Story Page | This page displays stories related to family members@@Storiesde81fabc03e040e7acb85a5d55fbcb8f:Family Story Page`,
          isContainer: true,
        },
      },
      {
        path: 'stories/connect',
        canActivate: [MasterGuard],
        loadChildren: () => import('@connect/connect-in-routing').then((m) => m.CONNECT_IN_ROUTING), // lazy loading
        data: {
          screenName: 'connect',
          memberPage: true,
          pageTitle: $localize`:Connect Page | This page facilitates user connections@@Storiese08aa077b1e1437bbced072d4e57247f:Connect Page`,
        },
      },
      {
        path: 'stories/fallback',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/fallback/fallback-routing').then((m) => m.FALLBACK_ROUTING), // lazy loading
        data: {
          screenName: 'fallback',
          pageTitle: $localize`:Fallback Page | This is the page displayed when no other route matches the requested URL@@Stories3141150564c240228130590d899b90c4:Fallback Page`,
          memberPage: true,
        },
      },
      {
        path: 'stories/public/fallback',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/fallback/fallback-routing').then((m) => m.FALLBACK_ROUTING), // lazy loading
        data: {
          screenName: 'fallback',
          pageTitle: $localize`:Fallback Page | This is the page displayed when no other route matches the requested URL@@Storiesfb469329b89d464386ee8aecacd76560:Fallback Page`,
          campaignIsRequired: true,
        },
      },
      {
        path: 'stories/deleted-screen',
        canActivate: [MasterGuard],
        component: DeletedScreenComponent,
        data: {
          screenName: 'deleted-screen',
          pageTitle: $localize`:Story Is No Longer Available | Message displayed when a user tries to access a story that has been removed or is no longer accessible@@Stories3f731debdc764598a7e6510a85f3ba93:Story Is No Longer Available`,
        },
      },
      {
        path: 'stories/preview',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/story-preview/story-preview-routing').then((m) => m.STORY_PREVIEW_ROUTING), // lazy loading
        data: {
          screenName: 'preview',
          pageTitle: $localize`:Story Preview Page | The title of the page where users can preview individual family stories@@Stories3d71ca2ae0dc4812a9b38643da5cbfea:Story Preview Page`,
        },
      },
      {
        path: 'stories/story-viewer/:storyid',
        canActivate: [MasterGuard],
        loadChildren: () =>
          import('@app/pages/story-viewer/story-viewer-routing').then((m) => m.WEBPARTS_VIEWER_ROUTING),
        data: {
          screenName: 'story-viewer',
          pageTitle: 'Story Viewer',
        },
      },
      {
        path: 'stories',
        canActivate: [MasterGuard],
        loadChildren: () => import('./pages/stories/stories-routing').then((m) => m.STORIES_ROUTING), // lazy loading
        data: {
          screenName: 'my-stories',
          appLoaderTitle: 'retrievingStories',
          memberPage: true,
          pageTitle: $localize`:Stories Home Page | The title displayed on the main page where users view their family stories@@Stories3f0a9dd2de9147d09c57a79a8b9c35b2:Stories Home Page`,
        },
      },
      {
        path: '**',
        loadChildren: () =>
          import('./pages/page-not-found/page-not-found-routing').then((m) => m.PAGE_NOT_FOUND_ROUTING), // lazy loading
        data: {
          screenName: 'not-found',
          pageTitle: $localize`:Page Not Found | The title displayed when the user lands on a 404 page@@Storiesd9b299398ad945c88c477f93bdc518a1:Error: Page Not Found`,
        },
      },
    ],
  },
]

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppRoutingModule {}
